import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Card, Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import AdminLayout from "../../../../component/AdminLayout";
import { GetEmailLicensingDashboard } from "../../../../API/api";
import GroupEmployeeList from "../../../../component/GroupEmployeeList";

type EmailLicenseCountList = {
  groupId: number;
  groupName: string;
  groupUser: string[];
};
const EmailDashboard = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [employeeList,setEmployeesList] = useState([]);
  const [isEmployeeListModalOpen,setIsEmployeeListModalOpen] = useState<boolean>(false)
  const [emailLicenseCount, setEmailLicenseCount] = useState<
    EmailLicenseCountList[]
  >([]);
  useEffect(() => {
    fetchEmailLicensingDashboard();
  }, []);

  const handleGroupCount = (text: any) =>{
    setEmployeesList(text.groupUser);
    setIsEmployeeListModalOpen(true);
  }
  const fetchEmailLicensingDashboard = async () => {
    try {
      setIsLoading(true);

      const response = await GetEmailLicensingDashboard();
      const newData = response.data.map(
        (softwareCountList: any, index: number) => ({
          ...softwareCountList,
          key: softwareCountList.groupId,
        })
      );
      setEmailLicenseCount(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      {" "}
      <AdminLayout>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
          <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px"}}>
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Email Licensing Dashboard
                </h3>
              </Col>
              <Col className="gutter-row pm-search-flex"  lg={{span: 10, offset: 2}} sm={24} xs={24} style={{ display: "flex"}}></Col>
            </Row>
          </div>
          <div>
          <Row gutter={16}>
      {emailLicenseCount.map((software, index) => (
        <Col key={index} lg={8} md={24} xs={24}>
        <div className="report-card">
          <Card title={software.groupName} bordered={false}>
            {/* Use software properties to populate the card content */}
            <hr style={{borderColor:"#00000012"}}/>
            <p style={{marginTop: "20px"}}>Count: <Button style={{ padding: "0px"}} type="link" onClick={()=>handleGroupCount(software)}>{software.groupUser.length}</Button></p>
          </Card>
          </div></Col>
      ))}
    </Row>
         
          </div>
        </div>
        {isEmployeeListModalOpen && (
          <GroupEmployeeList
            listData={employeeList}
            closePopup={() => setIsEmployeeListModalOpen(false)}
          />
        )}
        
      </AdminLayout>
    </>
  );
};
export default EmailDashboard;
